// import React from "react";
// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./assets/css/dashboard.css";
// import "./assets/css/dashboard-responsive.css";
// import "font-awesome/css/font-awesome.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";
// import "bootstrap/dist/js/bootstrap.min.js";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import Layout from "./Layout";
// import Protected from "./Protected";
// import Dashboard from "./Component/Home/Dashboard";
// import Login from "./Component/Login/Login";
// import OrderList from "./Component/Orders/OrderList";
// import TestimonialList from "./Component/Testimonials/TestimonialList";
// import TestimonialAdd from "./Component/Testimonials/TestimonialAdd";
// import TestimonialEdit from "./Component/Testimonials/TestimonialEdit";
// import CouponList from "./Pages/Coupons/CouponList.js";
// import CouponAdd from "./Pages/Coupons/CouponAdd.js";
// import Banner from "./Component/Banner/Banner";
// import BannerAdd from "./Component/Banner/BannerAdd";
// import BannerEdit from "./Component/Banner/BannerEdit";
// import Settings from "./Component/Settings/Settings";
// import CouponEdit from "./Pages/Coupons/CouponEdit.js";
// import AddQuestion from "./Question/AddQuestion";
// import QuestionList from "./Question/QuestionList";
// import PageNotFound from "./Component/404/PageNotFound";
// import AssignQuestionList from "./Question/AssignQuestionList";
// import EditQuestion from "./Question/EditQuestion";
// import Organizations from "./Pages/Organization/Organizations.js";
// import AddOrganization from "./Pages/Organization/AddOrganization.js";
// import EditOrganization from "./Pages/Organization/EditOrganization.js";
// import Sections from "./Pages/Section/Sections.js";
// import Addsection from "./Pages/Section/Addsection.js";
// import EditSection from "./Pages/Section/EditSection.js";
// import SubTopic from "./Pages/SubTopic/SubTopic.js";
// import AddSubTopic from "./Pages/SubTopic/AddSubTopic.js";
// import EditSubTopic from "./Pages/SubTopic/EditSubTopic.js";
// import Exams from "./Pages/Exam/Exams.js";
// import AddExam from "./Pages/Exam/AddExam.js";
// import EditExam from "./Pages/Exam/EditExam.js";
// import SubjectList from "./Pages/Subject/SubjectList.js";
// import AddSubject from "./Pages/Subject/AddSubject.js";
// import EditSubject from "./Pages/Subject/EditSubject.js";
// import TopicList from "./Pages/Topic/TopicList.js";
// import AddTopic from "./Pages/Topic/AddTopic.js";
// import EditTopic from "./Pages/Topic/EditTopic.js";
// import ViewExam from "./Pages/Exam/ViewExam.js";
// import Library from "./Pages/Library/Library.js";
// import AddLibrary from "./Pages/Library/AddLibrary.js";
// import EditLibrary from "./Pages/Library/EditLibrary.js";
// import ViewLibrary from "./Pages/Library/ViewLibrary.js";
// import MentorList from "./Pages/Mentor/MentorList.js";
// import AddMentor from "./Pages/Mentor/AddMentor.js";
// import Ebook from "./Pages/Ebook/Ebook.js";
// import ExamQuestions from "./Question/ExamQuestions.js";
// import LibraryBookingList from "./Pages/Orders/LibraryBookingList.js";
// import AddTenure from "./Pages/LibraryTenure/AddTenure.js";
// import Tenure from "./Pages/LibraryTenure/Tenure.js";
// import EditTenure from "./Pages/LibraryTenure/EditTenure.js";
// import Packages from "./Pages/Packages/Packages.js";

// import EditPackage from "./Pages/Packages/EditPackage.js";
// import ViewPackage from "./Pages/Packages/ViewPackage.js";
// import AddPackage from "./Pages/Packages/AddPackage.js";
// import PackageExams from "./Pages/Packages/PackageExams.js";
// import ExamsForAssign from "./Pages/Packages/ExamsForAssign.js";
// import EbookAdd from "./Pages/Ebook/EbookAdd.js";
// import EditEbook from "./Pages/Ebook/EditEbook.js";
// import EditMentor from "./Pages/Mentor/EditMentor.js";
// import ReferralList from "./Pages/Referral/ReferralList.js";
// import ViewMentor from "./Pages/Mentor/ViewMentor.js";
// import LanguageList from "./Pages/Language/LanguageList.js";
// import AddLanguage from "./Pages/Language/AddLanguage.js";
// import EditLanguage from "./Pages/Language/EditLanguage.js";
// import PackagePurchaseList from "./Pages/Orders/PackagePurchaseList.js";
// import EbookPurchaseList from "./Pages/Orders/EbookPurchaseList.js";
// import ListParagraph from "./Component/Paragraph/ListParagraph.js";
// import AddParagraph from "./Component/Paragraph/AddParagraph.js";
// import EditParagraph from "./Component/Paragraph/EditParagraph.js";
// import LibraryReport from "./Component/Reports/LibraryReport.js";
// import PackageReport from "./Component/Reports/PackageReport.js";
// import EbookReport from "./Component/Reports/EbookReport.js";
// import RoleList from "./Component/Roles/RoleList.jsx";
// import RoleForm from "./Component/Roles/RoleForm.jsx";
// import AddUser from "./Component/AdminUsers/AddUser.jsx";
// import AdminUserList from "./Component/AdminUsers/AdminUserList.jsx";
// import EditUser from "./Component/AdminUsers/EditUser.jsx";
// import Students from "./Component/Users/Students.js";
// function App() {
//   return (
//     <>
//       <BrowserRouter>
//         <Routes>
//           <Route path="login" element={<Login />} />

//           <Route path="/" element={<Layout />}>
//             <Route index element={<Protected Component={Dashboard} />} />
//             <Route path="banner" element={<Protected Component={Banner} />} />
//             <Route
//               path="banner-add"
//               element={<Protected Component={BannerAdd} />}
//             />
//             <Route
//               path="banner-edit/:id"
//               element={<Protected Component={BannerEdit} />}
//             />
//             <Route
//               path="students"
//               element={<Protected Component={Students} />}
//             />

//             <Route
//               path="orders"
//               element={<Protected Component={OrderList} />}
//             />
//             <Route
//               path="testimonials"
//               element={<Protected Component={TestimonialList} />}
//             />
//             <Route
//               path="testimonials/add"
//               element={<Protected Component={TestimonialAdd} />}
//             />
//             <Route
//               path="testimonials/edit/:id"
//               element={<Protected Component={TestimonialEdit} />}
//             />

//             <Route
//               path="/settings"
//               element={<Protected Component={Settings} />}
//             />


//             <Route path="library" element={<Protected Component={Library} />} />
//             <Route
//               path="library/add"
//               element={<Protected Component={AddLibrary} />}
//             />
//             <Route
//               path="library/edit/:id"
//               element={<Protected Component={EditLibrary} />}
//             />
//             <Route
//               path="library/view/:id"
//               element={<Protected Component={ViewLibrary} />}
//             />
//             <Route path="tenures" element={<Protected Component={Tenure} />} />
//             <Route
//               path="tenures/add"
//               element={<Protected Component={AddTenure} />}
//             />
//             <Route
//               path="tenures/edit/:id"
//               element={<Protected Component={EditTenure} />}
//             />
//             <Route
//               path="mentors"
//               element={<Protected Component={MentorList} />}
//             />
//             <Route
//               path="mentors/add"
//               element={<Protected Component={AddMentor} />}
//             />

//             <Route
//               path="mentors/edit/:id"
//               element={<Protected Component={EditMentor} />}
//             />
//             <Route
//               path="mentors/view/:id"
//               element={<Protected Component={ViewMentor} />}
//             />
//             <Route path="ebook" element={<Protected Component={Ebook} />} />
//             <Route
//               path="ebook/create"
//               element={<Protected Component={EbookAdd} />}
//             />
//             <Route
//               path="ebook/edit/:id"
//               element={<Protected Component={EditEbook} />}
//             />
//             <Route
//               path="organizations"
//               element={<Protected Component={Organizations} />}
//             />
//             <Route
//               path="organizations/create"
//               element={<Protected Component={AddOrganization} />}
//             />
//             <Route
//               path="organizations/edit/:id"
//               element={<Protected Component={EditOrganization} />}
//             />
//             <Route
//               path="sections"
//               element={<Protected Component={Sections} />}
//             />
//             <Route
//               path="sections/create"
//               element={<Protected Component={Addsection} />}
//             />
//             <Route
//               path="sections/edit/:id"
//               element={<Protected Component={EditSection} />}
//             />
//             <Route
//               path="subjects"
//               element={<Protected Component={SubjectList} />}
//             />
//             <Route
//               path="subjects/add"
//               element={<Protected Component={AddSubject} />}
//             />
//             <Route
//               path="subjects/edit/:id"
//               element={<Protected Component={EditSubject} />}
//             />
//             <Route
//               path="topics"
//               element={<Protected Component={TopicList} />}
//             />
//             <Route
//               path="topics/add"
//               element={<Protected Component={AddTopic} />}
//             />
//             <Route
//               path="topics/edit/:id"
//               element={<Protected Component={EditTopic} />}
//             />
//             <Route
//               path="subtopics"
//               element={<Protected Component={SubTopic} />}
//             />
//             <Route
//               path="subtopics/add"
//               element={<Protected Component={AddSubTopic} />}
//             />
//             <Route
//               path="subtopics/edit/:id"
//               element={<Protected Component={EditSubTopic} />}
//             />
//             <Route path="exams" element={<Protected Component={Exams} />} />
//             <Route
//               path="exams/create"
//               element={<Protected Component={AddExam} />}
//             />
//             <Route
//               path="exams/edit/:id"
//               element={<Protected Component={EditExam} />}
//             />
//             <Route
//               path="exams/view/:id"
//               element={<Protected Component={ViewExam} />}
//             />
//             <Route
//               path="exams/:id/questions"
//               element={<Protected Component={ExamQuestions} />}
//             />
//             <Route
//               path="packages"
//               element={<Protected Component={Packages} />}
//             />
//             <Route
//               path="packages/create"
//               element={<Protected Component={AddPackage} />}
//             />
//             <Route
//               path="packages/edit/:id"
//               element={<Protected Component={EditPackage} />}
//             />
//             <Route
//               path="packages/view/:id"
//               element={<Protected Component={ViewPackage} />}
//             />
//             <Route
//               path="packages/exams/:id"
//               element={<Protected Component={PackageExams} />}
//             />
//             <Route
//               path="packages/exams/:id/assign-exams"
//               element={<Protected Component={ExamsForAssign} />}
//             />
//             <Route
//               path="exams/:id/questions/assign"
//               element={<Protected Component={AssignQuestionList} />}
//             />
//             <Route
//               path="/questions/create"
//               element={<Protected Component={AddQuestion} />}
//             />
//             <Route
//               path="/questions/edit/:id"
//               element={<Protected Component={EditQuestion} />}
//             />
//             <Route
//               path="/questions"
//               element={<Protected Component={QuestionList} />}
//             />
//             <Route
//               path="test-series/questions/assign/:id"
//               element={<Protected Component={AssignQuestionList} />}
//             />

//             <Route
//               path="orders/library-bookings"
//               element={<Protected Component={LibraryBookingList} />}
//             />
//             <Route
//               path="orders/package-purchase"
//               element={<Protected Component={PackagePurchaseList} />}
//             />
//             <Route
//               path="orders/ebook-purchase"
//               element={<Protected Component={EbookPurchaseList} />}
//             />

//             <Route
//               path="/coupons"
//               element={<Protected Component={CouponList} />}
//             />
//             <Route
//               path="/coupons/add"
//               element={<Protected Component={CouponAdd} />}
//             />
//             <Route
//               path="/coupons/edit/:id"
//               element={<Protected Component={CouponEdit} />}
//             />
//             <Route
//               path="/languages"
//               element={<Protected Component={LanguageList} />}
//             />
//             <Route
//               path="/languages/add"
//               element={<Protected Component={AddLanguage} />}
//             />
//             <Route
//               path="/languages/edit/:id"
//               element={<Protected Component={EditLanguage} />}
//             />
//             <Route
//               path="/referrals"
//               element={<Protected Component={ReferralList} />}
//             />
//             <Route
//               path="/reports/library-report"
//               element={<Protected Component={LibraryReport} />}
//             />
//             <Route
//               path="/reports/package-report"
//               element={<Protected Component={PackageReport} />}
//             />
//             <Route
//               path="/reports/ebook-report"
//               element={<Protected Component={EbookReport} />}
//             />
//             <Route
//               path="/paragraph"
//               element={<Protected Component={ListParagraph} />}
//             />
//             <Route
//               path="/paragraph/add"
//               element={<Protected Component={AddParagraph} />}
//             />
//             <Route
//               path="/paragraph/edit/:id"
//               element={<Protected Component={EditParagraph} />}
//             />


//             <Route
//               path="/roles"
//               element={<Protected Component={RoleList} />}
//             />
//             <Route
//               path="/roles/create"
//               element={<Protected Component={RoleForm} />}
//             />
//             <Route
//               path="/roles/edit/:id"
//               element={<Protected Component={RoleForm} />}
//             />
//             <Route
//               path="/admin-users"
//               element={<Protected Component={AdminUserList} />}
//             />
//             <Route
//               path="/admin-users/create"
//               element={<Protected Component={AddUser} />}
//             />
//             <Route
//               path="/admin-users/edit/:id"
//               element={<Protected Component={EditUser} />}
//             />
//           </Route>
//           <Route path="*" element={<PageNotFound />} />
//         </Routes>
//       </BrowserRouter>
//       <ToastContainer />
//     </>
//   );
// }

// export default App;



import "bootstrap/dist/css/bootstrap.css"
import "bootstrap/dist/css/bootstrap.min.css"
import "./assets/css/dashboard.css"
import "./assets/css/dashboard-responsive.css"
import "font-awesome/css/font-awesome.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min"
import "bootstrap/dist/js/bootstrap.min.js"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import Layout from "./Layout"
import Protected from "./Protected"
import Dashboard from "./Component/Home/Dashboard"
import Login from "./Component/Login/Login"
import OrderList from "./Component/Orders/OrderList"
import TestimonialList from "./Component/Testimonials/TestimonialList"
import TestimonialAdd from "./Component/Testimonials/TestimonialAdd"
import TestimonialEdit from "./Component/Testimonials/TestimonialEdit"
import CouponList from "./Pages/Coupons/CouponList.js"
import CouponAdd from "./Pages/Coupons/CouponAdd.js"
import Banner from "./Component/Banner/Banner"
import BannerAdd from "./Component/Banner/BannerAdd"
import BannerEdit from "./Component/Banner/BannerEdit"
import Settings from "./Component/Settings/Settings"
import CouponEdit from "./Pages/Coupons/CouponEdit.js"
import AddQuestion from "./Question/AddQuestion"
import QuestionList from "./Question/QuestionList"
import PageNotFound from "./Component/404/PageNotFound"
import AssignQuestionList from "./Question/AssignQuestionList"
import EditQuestion from "./Question/EditQuestion"
import Organizations from "./Pages/Organization/Organizations.js"
import AddOrganization from "./Pages/Organization/AddOrganization.js"
import EditOrganization from "./Pages/Organization/EditOrganization.js"
import Sections from "./Pages/Section/Sections.js"
import Addsection from "./Pages/Section/Addsection.js"
import EditSection from "./Pages/Section/EditSection.js"
import SubTopic from "./Pages/SubTopic/SubTopic.js"
import AddSubTopic from "./Pages/SubTopic/AddSubTopic.js"
import EditSubTopic from "./Pages/SubTopic/EditSubTopic.js"
import Exams from "./Pages/Exam/Exams.js"
import AddExam from "./Pages/Exam/AddExam.js"
import EditExam from "./Pages/Exam/EditExam.js"
import SubjectList from "./Pages/Subject/SubjectList.js"
import AddSubject from "./Pages/Subject/AddSubject.js"
import EditSubject from "./Pages/Subject/EditSubject.js"
import TopicList from "./Pages/Topic/TopicList.js"
import AddTopic from "./Pages/Topic/AddTopic.js"
import EditTopic from "./Pages/Topic/EditTopic.js"
import ViewExam from "./Pages/Exam/ViewExam.js"
import Library from "./Pages/Library/Library.js"
import AddLibrary from "./Pages/Library/AddLibrary.js"
import EditLibrary from "./Pages/Library/EditLibrary.js"
import ViewLibrary from "./Pages/Library/ViewLibrary.js"
import MentorList from "./Pages/Mentor/MentorList.js"
import AddMentor from "./Pages/Mentor/AddMentor.js"
import Ebook from "./Pages/Ebook/Ebook.js"
import ExamQuestions from "./Question/ExamQuestions.js"
import LibraryBookingList from "./Pages/Orders/LibraryBookingList.js"
import AddTenure from "./Pages/LibraryTenure/AddTenure.js"
import Tenure from "./Pages/LibraryTenure/Tenure.js"
import EditTenure from "./Pages/LibraryTenure/EditTenure.js"
import Packages from "./Pages/Packages/Packages.js"
import EditPackage from "./Pages/Packages/EditPackage.js"
import ViewPackage from "./Pages/Packages/ViewPackage.js"
import AddPackage from "./Pages/Packages/AddPackage.js"
import PackageExams from "./Pages/Packages/PackageExams.js"
import ExamsForAssign from "./Pages/Packages/ExamsForAssign.js"
import EbookAdd from "./Pages/Ebook/EbookAdd.js"
import EditEbook from "./Pages/Ebook/EditEbook.js"
import EditMentor from "./Pages/Mentor/EditMentor.js"
import ReferralList from "./Pages/Referral/ReferralList.js"
import ViewMentor from "./Pages/Mentor/ViewMentor.js"
import LanguageList from "./Pages/Language/LanguageList.js"
import AddLanguage from "./Pages/Language/AddLanguage.js"
import EditLanguage from "./Pages/Language/EditLanguage.js"
import PackagePurchaseList from "./Pages/Orders/PackagePurchaseList.js"
import EbookPurchaseList from "./Pages/Orders/EbookPurchaseList.js"
import ListParagraph from "./Component/Paragraph/ListParagraph.js"
import AddParagraph from "./Component/Paragraph/AddParagraph.js"
import EditParagraph from "./Component/Paragraph/EditParagraph.js"
import LibraryReport from "./Component/Reports/LibraryReport.js"
import PackageReport from "./Component/Reports/PackageReport.js"
import EbookReport from "./Component/Reports/EbookReport.js"

import Students from "./Component/Users/Students.js"
import RoleList from "./Component/Roles/RoleList.jsx"
import AdminUserList from "./Component/AdminUsers/AdminUserList.jsx"
import RoleForm from "./Component/Roles/RoleForm.jsx"
import AddUser from "./Component/AdminUsers/AddUser.jsx"
import EditUser from "./Component/AdminUsers/EditUser.jsx"

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="login" element={<Login />} />

          <Route path="/" element={<Layout />}>
            <Route index element={<Protected Component={Dashboard} permission="dashboard:view" />} />
            <Route path="banner" element={<Protected Component={Banner} permission="banner:view" />} />
            <Route path="banner-add" element={<Protected Component={BannerAdd} permission="banner:create" />} />
            <Route path="banner-edit/:id" element={<Protected Component={BannerEdit} permission="banner:edit" />} />
            <Route path="students" element={<Protected Component={Students} permission="user:view" />} />

            <Route path="orders" element={<Protected Component={OrderList} permission="order:view" />} />
            <Route
              path="testimonials"
              element={<Protected Component={TestimonialList} permission="testimonial:view" />}
            />
            <Route
              path="testimonials/add"
              element={<Protected Component={TestimonialAdd} permission="testimonial:create" />}
            />
            <Route
              path="testimonials/edit/:id"
              element={<Protected Component={TestimonialEdit} permission="testimonial:edit" />}
            />

            <Route path="/settings" element={<Protected Component={Settings} permission="settings:view" />} />

            <Route path="library" element={<Protected Component={Library} permission="library:view" />} />
            <Route path="library/add" element={<Protected Component={AddLibrary} permission="library:create" />} />
            <Route path="library/edit/:id" element={<Protected Component={EditLibrary} permission="library:edit" />} />
            <Route path="library/view/:id" element={<Protected Component={ViewLibrary} permission="library:view" />} />
            <Route path="tenures" element={<Protected Component={Tenure} permission="tenure:view" />} />
            <Route path="tenures/add" element={<Protected Component={AddTenure} permission="tenure:create" />} />
            <Route path="tenures/edit/:id" element={<Protected Component={EditTenure} permission="tenure:edit" />} />
            <Route path="mentors" element={<Protected Component={MentorList} permission="mentor:view" />} />
            <Route path="mentors/add" element={<Protected Component={AddMentor} permission="mentor:create" />} />
            <Route path="mentors/edit/:id" element={<Protected Component={EditMentor} permission="mentor:edit" />} />
            <Route path="mentors/view/:id" element={<Protected Component={ViewMentor} permission="mentor:view" />} />
            <Route path="ebook" element={<Protected Component={Ebook} permission="ebook:view" />} />
            <Route path="ebook/create" element={<Protected Component={EbookAdd} permission="ebook:create" />} />
            <Route path="ebook/edit/:id" element={<Protected Component={EditEbook} permission="ebook:edit" />} />
            <Route
              path="organizations"
              element={<Protected Component={Organizations} permission="organization:view" />}
            />
            <Route
              path="organizations/create"
              element={<Protected Component={AddOrganization} permission="organization:create" />}
            />
            <Route
              path="organizations/edit/:id"
              element={<Protected Component={EditOrganization} permission="organization:edit" />}
            />
            <Route path="sections" element={<Protected Component={Sections} permission="section:view" />} />
            <Route path="sections/create" element={<Protected Component={Addsection} permission="section:create" />} />
            <Route path="sections/edit/:id" element={<Protected Component={EditSection} permission="section:edit" />} />
            <Route path="subjects" element={<Protected Component={SubjectList} permission="subject:view" />} />
            <Route path="subjects/add" element={<Protected Component={AddSubject} permission="subject:create" />} />
            <Route path="subjects/edit/:id" element={<Protected Component={EditSubject} permission="subject:edit" />} />
            <Route path="topics" element={<Protected Component={TopicList} permission="topic:view" />} />
            <Route path="topics/add" element={<Protected Component={AddTopic} permission="topic:create" />} />
            <Route path="topics/edit/:id" element={<Protected Component={EditTopic} permission="topic:edit" />} />
            <Route path="subtopics" element={<Protected Component={SubTopic} permission="subtopic:view" />} />
            <Route path="subtopics/add" element={<Protected Component={AddSubTopic} permission="subtopic:create" />} />
            <Route
              path="subtopics/edit/:id"
              element={<Protected Component={EditSubTopic} permission="subtopic:edit" />}
            />
            <Route path="exams" element={<Protected Component={Exams} permission="exam:view" />} />
            <Route path="exams/create" element={<Protected Component={AddExam} permission="exam:create" />} />
            <Route path="exams/edit/:id" element={<Protected Component={EditExam} permission="exam:edit" />} />
            <Route path="exams/view/:id" element={<Protected Component={ViewExam} permission="exam:view" />} />
            <Route
              path="exams/:id/questions"
              element={<Protected Component={ExamQuestions} permission="question:view" />}
            />
            <Route path="packages" element={<Protected Component={Packages} permission="package:view" />} />
            <Route path="packages/create" element={<Protected Component={AddPackage} permission="package:create" />} />
            <Route path="packages/edit/:id" element={<Protected Component={EditPackage} permission="package:edit" />} />
            <Route path="packages/view/:id" element={<Protected Component={ViewPackage} permission="package:view" />} />
            <Route
              path="packages/exams/:id"
              element={<Protected Component={PackageExams} permission="package:view" />}
            />
            <Route
              path="packages/exams/:id/assign-exams"
              element={<Protected Component={ExamsForAssign} permission="package:edit" />}
            />
            <Route
              path="exams/:id/questions/assign"
              element={<Protected Component={AssignQuestionList} permission="question:edit" />}
            />
            <Route
              path="/questions/create"
              element={<Protected Component={AddQuestion} permission="question:create" />}
            />
            <Route
              path="/questions/edit/:id"
              element={<Protected Component={EditQuestion} permission="question:edit" />}
            />
            <Route path="/questions" element={<Protected Component={QuestionList} permission="question:view" />} />
            <Route
              path="test-series/questions/assign/:id"
              element={<Protected Component={AssignQuestionList} permission="question:edit" />}
            />

            <Route
              path="orders/library-bookings"
              element={<Protected Component={LibraryBookingList} permission="order:view" />}
            />
            <Route
              path="orders/package-purchase"
              element={<Protected Component={PackagePurchaseList} permission="order:view" />}
            />
            <Route
              path="orders/ebook-purchase"
              element={<Protected Component={EbookPurchaseList} permission="order:view" />}
            />

            <Route path="/coupons" element={<Protected Component={CouponList} permission="coupon:view" />} />
            <Route path="/coupons/add" element={<Protected Component={CouponAdd} permission="coupon:create" />} />
            <Route path="/coupons/edit/:id" element={<Protected Component={CouponEdit} permission="coupon:edit" />} />
            <Route path="/languages" element={<Protected Component={LanguageList} permission="language:view" />} />
            <Route path="/languages/add" element={<Protected Component={AddLanguage} permission="language:create" />} />
            <Route
              path="/languages/edit/:id"
              element={<Protected Component={EditLanguage} permission="language:edit" />}
            />
            <Route path="/referrals" element={<Protected Component={ReferralList} permission="referral:view" />} />
            <Route
              path="/reports/library-report"
              element={<Protected Component={LibraryReport} permission="report:view" />}
            />
            <Route
              path="/reports/package-report"
              element={<Protected Component={PackageReport} permission="report:view" />}
            />
            <Route
              path="/reports/ebook-report"
              element={<Protected Component={EbookReport} permission="report:view" />}
            />
            <Route path="/paragraph" element={<Protected Component={ListParagraph} permission="question:view" />} />
            <Route
              path="/paragraph/add"
              element={<Protected Component={AddParagraph} permission="question:create" />}
            />
            <Route
              path="/paragraph/edit/:id"
              element={<Protected Component={EditParagraph} permission="question:edit" />}
            />
            <Route path="/roles" element={<Protected Component={RoleList} permission="role:view" />} />
            <Route path="/admin-users" element={<Protected Component={AdminUserList} permission="user:view" />} />

            <Route path="/roles/create" element={<Protected Component={RoleForm} permission="role:create" />} />
            <Route path="/roles/edit/:id" element={<Protected Component={RoleForm} permission="role:edit" />} />
            <Route path="/admin-users/create" element={<Protected Component={AddUser} permission="user:create" />} />
            <Route path="/admin-users/edit/:id" element={<Protected Component={EditUser} permission="user:edit" />} />
          </Route>
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  )
}

export default App
